import { IonCol, IonDatetime, IonGrid, IonIcon, IonRow, IonSelect, IonSelectOption } from '@ionic/react';
import { calendar } from 'ionicons/icons';
import moment from 'moment';

export const RequiredByDateFilter = ({
  operator,
  date,
  onOperatorChange,
  onRequiredByDateChange,
 minLimit = null
}) => (
  <IonGrid fixed>
    <IonRow class='ion-align-items-center'>
      <IonCol size='1'>
        <IonIcon icon={calendar} />
      </IonCol>

      <IonCol size='2'>
        <IonSelect
          value={operator}
          onIonChange={e => {
            onOperatorChange(e.detail.value);
          }}
        >
          <IonSelectOption value='='>=</IonSelectOption>
          <IonSelectOption value='=<'>&lt;</IonSelectOption>
          <IonSelectOption value='=>'>&gt;</IonSelectOption>
        </IonSelect>
      </IonCol>

      <IonCol size='9'>
        <IonDatetime
          key={date === '' ? 'empty' : date}
          presentation='date'
          placeholder='Enter date'
          value={date}
          min={minLimit ? moment(minLimit).format('YYYY-MM-DD') : undefined}
          onIonChange={e => onRequiredByDateChange(moment(e.detail.value).format('YYYY-MM-DD'))}
        />
      </IonCol>
    </IonRow>
  </IonGrid>
);
